// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__FkTXl","footer":"ReportModalFilter_footer__28aZY"};